export const getCognitoUserPoolId = () => {
    const value = process.env.NEXT_PUBLIC_AWS_COGNITO_USERPOOL_ID;
    if (!value) {
        throw new Error("Missing env var NEXT_PUBLIC_AWS_COGNITO_USERPOOL_ID");
    }
    return value;
};

export const getCognitoAppClientId = () => {
    const value = process.env.NEXT_PUBLIC_AWS_COGNITO_APP_CLIENT_ID;
    if (!value) {
        throw new Error(
            "Missing env var NEXT_PUBLIC_AWS_COGNITO_APP_CLIENT_ID",
        );
    }
    return value;
};

export const getRestApiEndpoint = () => {
    const value = process.env.NEXT_PUBLIC_REST_API_ENDPOINT;
    if (!value) {
        throw new Error("Missing env var NEXT_PUBLIC_REST_API_ENDPOINT");
    }
    return value;
};

/*
 * Get's the current environment based on the NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF.
 * Also works in the browser
 */
export const getEnvironment = (): "production" | "development" | "staging" => {
    if (process.env.NEXT_PUBLIC_ENV_OVERRIDE) {
        return process.env.NEXT_PUBLIC_ENV_OVERRIDE as
            | "production"
            | "development"
            | "staging";
    }
    if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "production") {
        return "production";
    }
    if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "staging") {
        return "staging";
    }

    if (process.env.ENVIRONMENT) {
        return process.env.ENVIRONMENT.toLowerCase() as
            | "production"
            | "development"
            | "staging";
    }
    return "development";
};

export const getBucketUrl = (bucketName: `consola-${string}-bucket`) => {
    return `https://${bucketName}-${getEnvironment()}.s3.amazonaws.com/`;
};
